<template>
  <va-show :item="item">
    <va-field source="title"></va-field>
    <va-field source="content"></va-field>
  </va-show>
</template>

<script>
export default {
  props: ["item"],
};
</script>
